import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Main } from "../MobileMenu.components.js";
import MobileMenuItem from "./MobileMenuItem.js";
export const MobileMenuMainComponent = ({ data, isLoading, selectedId, }) => {
    if (!data?.length)
        return null;
    return (_jsx(Main, { children: data.map((navigationItem, i) => (_createElement(MobileMenuItem, { ...navigationItem, isLoading: isLoading, selectedId: selectedId, key: i }))) }));
};
export default MobileMenuMainComponent;
